import RandomId from '@/docs-partials/api/endpoints/random-id.mdx';
import * as React from 'react';
export default {
  RandomId,
  React
};